import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
})
export class SectionHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() tooltip: string;
  @Input() showTooltip: boolean = true;
  @Input() tooltipStyleClass: string = 'netz-info-tooltip';
  @Input() tooltipPosition: 'left' | 'bottom' = 'left';

  constructor() {}

  ngOnInit(): void {}
}
